<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="800px"
  >
    <confirm-dialog
      v-model="isConfirmRemoveDialogOpened"
      @no="isConfirmRemoveDialogOpened = false"
      @yes="remove"
    />
    <v-form @submit.prevent.native="$canWrite && (update($event))">
      <v-card v-if="hasRecurrentIntervention">
        <v-card-title>
          Modifier une intervention récurrente
          <v-spacer></v-spacer>
          <v-btn icon @click="isOpened = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0" v-if="isOpened">
          <recurrent-intervention-recurrence-form show-next-at class="mb-2" />
          <div class="pa-4">
            <recurrent-intervention-form
              @isValid="isValid => canSubmit = isValid"
            />
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-3 px-4">
          <v-btn
            :disabled="!$canWrite"
            text
            color="error"
            class="pr-4"
            @click="$canWrite && (isConfirmRemoveDialogOpened = true)"
            v-if="!isRemoving"
          >
            <v-icon left>delete</v-icon>
            Supprimer
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            class="px-4"
            @click="isOpened = false"
            v-if="!isUpdating && !isRemoving"
          >
            Annuler
          </v-btn>
          <v-btn
            type="submit"
            color="primary darken-1"
            class="px-4"
            :loading="isUpdating"
            :disabled="!$canWrite || (!canSubmit)"
            v-if="!isRemoving"
          >
            Modifier
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import RecurrentInterventionRecurrenceForm from '@/components/RecurrentInterventions/RecurrenceForm.vue';
import RecurrentInterventionForm from '@/components/RecurrentInterventions/Form.vue';
import { mapActions } from 'vuex';

export default {
  data: () => ({
    isConfirmRemoveDialogOpened: false,
    isRemoving: false,
    isUpdating: false,
    canSubmit: false,
  }),

  props: {
    value: Boolean,
    recurrentIntervention: {
      type: Object,
      required: false,
    },
  },

  computed: {
    isOpened: {
      get() { return this.value; },
      set(isOpened) {
        return this.$emit(`input`, isOpened);
      },
    },
    hasRecurrentIntervention() {
      return Boolean(this.recurrentIntervention && this.recurrentIntervention.id);
    },
  },

  methods: {
    ...mapActions(`ui/recurrentInterventionForm`, [
      `setRecurrentIntervention`,
      `updateRecurrentIntervention`,
      `removeRecurrentIntervention`,
    ]),
    initOpen() {
      this.setRecurrentIntervention(this.recurrentIntervention);
    },
    async update() {
      this.isUpdating = true;
      await this.updateRecurrentIntervention();
      this.isUpdating = false;
      this.isOpened = false;
      this.$emit(`updated`);
    },
    async remove() {
      this.isRemoving = true;
      await this.removeRecurrentIntervention();
      this.isRemoving = false;
      this.isOpened = false;
      this.$emit(`removed`);
    },
  },

  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initOpen();
      }
    },
  },

  components: {
    RecurrentInterventionRecurrenceForm,
    RecurrentInterventionForm,
  },
};
</script>

<style lang="scss" scoped>
</style>
